// extracted by mini-css-extract-plugin
export default {"logo_image":"NavLogo_logo_image__k0viT","svg_container":"NavLogo_svg_container__zY+xS"};